export const EMAIL_REGEXP = /^([a-zA-Z0-9_?!+\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,50})$/

export const NUMBER_AND_LATIN_AND_SYMBOLS_REGEXP = /^[a-zA-Z0-9!@#$%^&*()-_=+.\s]+$/

export const LATIN_ONLY_MIN2 = /^[A-Za-z]{2,}$/

export const NAME_REGEXP = /^[A-Za-z\- ]{2,}$/

export const LATIN_DIGIT_ONLY_2_TO_16 = /^[A-Za-z0-9]{2,16}$/
export const LATIN_DIGIT_SPACE_2_TO_16 = /^[A-Za-z0-9 ]{2,16}$/

export const PASSWORD_REGEXP =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+.])[a-zA-Z\d!@#$%^&*()\-_=+]{8,16}$/

export const PASSWORD_ALLOWED_CHAR_PATTERN = /^[a-zA-Z\d!@#$%^&*()\-_=+]+$/

export const PHONE_REGEXP = /^\+\d{7,15}$/

export const ACCOUNT_NAME_REGEXP = /^[a-zA-Z0-9 _#@-]{1,32}$/
